var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('toggle-input-v2',{attrs:{"value":_vm.value,"disabled":_vm.disabled,"loading":_vm.loading,"title":"Post issues as inline PR comments","description":"When enabled, DeepSource will post issues as inline comments on pull requests."},on:{"toggle":(...args) => _vm.$emit('toggle', ...args)}})
}
var staticRenderFns = []

export { render, staticRenderFns }